import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import SkillFilterCriteria from './SkillFilterCriteria'
import SkillList from './SkillList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './SkillAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setSkillDashboardSkillList } from '../../store/slice/ManufSlice';

export default function SkillListView({setShowEdit,setSkillId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.skillDashboard);   

    const [filteredSkillList, setFilteredSkillList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { skillDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (skillDashboard.skillList.length>-1){
        setFilteredSkillList(skillDashboard.skillList);
        transformToCardFormat(skillDashboard.skillList, setCardList);
      }
    },[skillDashboard.skillList])

    useEffect(()=>{
          transformToCardFormat(filteredSkillList, setCardList);
      },[filteredSkillList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredSkillList(skillDashboard.skillList);
            transformToCardFormat(skillDashboard.skillList, setCardList);

        } else {
            setFilteredSkillList(
                skillDashboard.skillList
                    .filter(skill=> skill.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(skillDashboard.filteredSkillList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <SkillList
                    setShowEdit={setShowEdit}
                    setSkillId = {setSkillId}
                    tableList={filteredSkillList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}